<template>
	<div v-if="blok.image_link">
		<nuxt-link
			:to="blok.image_link.cached_url"
			class="flex flex-col items-center"
			:name="blok.image.title"
		>
			<NuxtImg
				v-if="blok.image.filename"
				:src="blok.image.filename"
				:loading="blok.lazyLoading ? 'lazy' : 'eager'"
				:preload="!blok.lazyLoading"
				format="webp"
				provider="storyblok"
				:class="`min-h-4 min-w-4 ${storyblokImgDimensions.width ? '' : extraClasses} max-w-full`"
				:alt="blok.image.alt"
				:width="+storyblokImgDimensions.width"
				:height="+storyblokImgDimensions?.height"
				fit="in"
				:placeholder="
					img(blok.image.filename, { h: 10, f: 'webp', blur: 2, q: 50 })
				"
			/>
		</nuxt-link>
	</div>
	<div v-else>
		<NuxtImg
			v-if="blok.image.filename"
			:src="blok.image.filename"
			:loading="blok.lazyLoading ? 'lazy' : 'eager'"
			:preload="!blok.lazyLoading"
			format="webp"
			provider="storyblok"
			:class="`min-h-4 min-w-4 ${storyblokImgDimensions.width ? '' : extraClasses} max-w-full`"
			:alt="blok.image.alt"
			:width="+storyblokImgDimensions.width"
			:height="+storyblokImgDimensions?.height"
			fit="in"
			:placeholder="
				img(blok.image.filename, { h: 10, f: 'webp', blur: 2, q: 50 })
			"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { BlokImage } from "~/types/storyblok/storyblok";

const img = useImage();

interface Props {
	blok: BlokImage;
	extraClasses?: string;
	imageSize?: string;
}
const { blok, imageSize } = defineProps<Props>();

const storyblokImgDimensions = computed(() => {
	if (imageSize) {
		return { width: imageSize, height: 0 };
	}
	return {
		width: blok.maxWidth,
		height: blok.maxHeight
	};
});
</script>
